define('app',[
  'default-controller',
  'filter-service',
  'currency-service',
  'tmh-dynamicLocale',
  'slugifier'

], function() {

  var app = angular.module('app', [
    // {{angular.module}}
    'default.controller',
    'filter.service',
    'currency.service',
    'tmh.dynamicLocale',
    'ngMaterial',
    'slugifier'

  ]);


  app.config(["tmhDynamicLocaleProvider", "$mdThemingProvider", "$locationProvider", "$mdDateLocaleProvider",
  function(tmhDynamicLocaleProvider, $mdThemingProvider, $locationProvider, $mdDateLocaleProvider) {
    var metaLanguage = angular.element('meta[name="language"]');
    $mdThemingProvider.theme('default');
    tmhDynamicLocaleProvider.localeLocationPattern('/site/public/app/lib/i18n-angular/angular-locale_'+metaLanguage[0].content+'.js');

    $locationProvider.html5Mode(true).hashPrefix('&');

    $mdDateLocaleProvider.formatDate = function(date) {
      var m = moment(date);
      return   m.isValid() ? moment(date).format('DD/MM/YYYY') : '';
    };

  }]);





  return app;

});

